<template>
  <static-fullscreen-card>
    <portal to="v-goup" v-if="idShow">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <template v-slot:title>
      ({{ data.id }}){{ data.parent_id ? "Дополнение к " : "" }} {{ `${data.contract_number || "Без номера"}` }} [{{ statusCurrent.text || "" }}]
    </template>
    <template v-slot:actions>
      <a-btn-send-code v-if="id && data.status === 1" :id="id" :api="api" @success="fitchData(id)" :title="'Подпись(SMS)'" :buttons="{ send: 'Подписать' }" />
      <v-btn v-if="data.status == 2 && data.print_act" :href="$root.config.fileUrl + data.print_act" target="_blank" class="mx-1" dark color="info" title="Скачать">
        <v-icon dark>fas fa-file-signature </v-icon>
      </v-btn>
      <v-btn v-else-if="data.id" :href="getPreview()" target="_blank" class="mx-1" dark color="info" title="Предпросмотр">
        <v-icon dark>fas fa-eye </v-icon>
      </v-btn>
      <a-btn-kontur-sign v-if="id" :id="id" :api="api" :values="data" :status="data.status" @success="fitchData(id)" />
      <a-btn-status v-if="getAccess('contract.status', { users: [data.createdby_id] })" :items="statusItems" @click="changeStatus($event)" :disabled="canStatus" />
      <a-btn-edit v-if="accessEdit && (data.status === 0 || statusCurrent.canEdit) && !data.parent_id" @click="contractEdit" :disabled1="!canEdit" />
      <a-btn-add v-if="data.parent_id" @click="onClickRow({ row: { id: data.parent_id } })" :title="'Основной договор'" :hasIcon="false" />
      <a-btn-delete
        v-if="id && getAccess('contract.delete', { users: [data.createdby_id] }) && (data.status || 0) === 0"
        :disabled="!canDelete"
        @click="removeDialogShow = true"
      />
    </template>
    <v-row>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading> </template>
          <a-form-view :value="data.parent_id ? data.parent : data" :model="modelLeft" :config="{ dense: true, hideNull: true }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6" class="px-2">
        <material-card color="secondary">
          <template v-slot:heading> </template>
          <a-form-view :value="data" :model="modelRight" :config="{ dense: true, hideNull: true }" />
          <v-btn
            color="primary"
            v-if="cost_contract && cost_contract.prepay && data.contract_type == 1"
            @click.stop="makeInvoice()"
            class="px-2 ma-1"
            :title="invoice_btn_title"
            :loading="invoice_id === null"
          >
            <v-icon>fas fa-qrcode</v-icon>
            <btn-title v-if="$vuetify.breakpoint[`smAndUp`]">{{ invoice_btn_title }}</btn-title>
          </v-btn>
          <a-btn-add
            v-if="cost_contract && cost_contract.price && [1, 2].includes(data.contract_type)"
            class="ma-1"
            @click="scheduleDialog()"
            :title="'График платежей'"
            :icon="'fas fa-layer-group'"
          />
        </material-card>
      </v-col>
      <v-col cols="12" sm="12" class="px-2 pt-1">
        <material-card color="third" class="block_detail">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(t, i) in tabs" v-if="t.show" :key="i" class="mr-3" :href="`#tab-${t.name}`"> {{ t.title }} </v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item v-for="(t, i) in tabs" :key="i" v-if="t.show" :id="`tab-${t.name}`">
              <v-card-text v-if="t.name == 'addition'" :style="`height: ${detailHeight}px; overflow: auto`" class="pa-0">
                <a-table-f-api
                  ref="tableAddition"
                  :api="api"
                  :model="getModelList(m, `listAddition`)"
                  :searchable="false"
                  :defaults="{
                    filters: { parent_id: id },
                    sort: { key: 'id', order: 'DESC' },
                    paramName: 'tabContract',
                  }"
                  @click="onClickRow($event)"
                >
                  <template v-slot:top v-if="getAccess('contract.create')">
                    <v-fab-transition v-if="data.status === 0 || statusCurrent.canEdit">
                      <v-btn fab dark color="green" absolute bottom small style="bottom: 15px" left class="v-btn--example" @click="additionAdd">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-fab-transition>
                  </template>
                </a-table-f-api>
              </v-card-text>
              <v-card-text v-if="t.name == 'files'" :style="styleDetailCard" class="pa-0">
                <v-fab-transition v-if="data.status === 0 || statusCurrent.canEdit">
                  <v-btn fab dark color="green" absolute bottom small style="bottom: 25px" left class="v-btn--example" @click="addNewDocs('docs')">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-fab-transition>
                <a-view-filesdata :value="data.filesData" />
              </v-card-text>
              <s-tabs-status-history v-if="t.name == 'statusHistory'" :data="data.status_history" :m="m" :height="detailHeight" />
              <v-card-text v-if="t.name == 'appendix'" :style="`height: ${detailHeight}px; overflow: auto`" class="pa-0">
                <TabAppendix :data="appendixTable" @add="appendixAdd()" @edit="appendixEdit($event)" @delete="appendixDelete($event)" />
              </v-card-text>
              <v-card-text v-if="t.name == 'comments'" :style="`height: ${detailHeight}px; overflow: auto`">
                <comment-view :id="id || 0" :targetName="'contract'" :needUpdate="needUpdateComments" :height="detailHeight" />
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
    <portal to="v-main">
      <s-edit-form
        v-if="showEditDialog"
        version="2"
        v-model="showEditDialog"
        :m="configH.m"
        :configForm="{ head: configH.head, title: configH.title, api: configH.api }"
        :id="configH.id"
        :opt="configH.opt"
        :initData="configH.initData || {}"
        :params="configH"
      />
      <s-document-head v-if="showEditDialog && false" v-model="showEditDialog" :api="url" :m="m" :config="configHead" :title="m.title" :id="id" />
      <su-Data ref="suEdit" v-model="suEditShow" :api="api" :id="id" :activate="true" :dataEdit="data" @show="suEditShow = true" v-if="getAccess('suData')" />
      <s-quick-addDocument v-if="showAddDocDialog" v-model="showAddDocDialog" :id="id" :api="url" :modelDoc="addDocModel" />
      <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" :title="removeTitle" />
      <s-document-dialogs-detail-edit
        ref="editAppendix"
        v-if="showAppendixEditDialog"
        v-model="showAppendixEditDialog"
        :id="idEdit"
        :dataTable="appendixTable"
        :readonly="data.status == 2"
        :RO="fieldsRO"
        :m="m"
        type="appendix"
        @onChange="onChange($event)"
        @save="appendixTable = $event"
        @refresh="fitchData()"
      >
        <template v-slot:form="{ item }">
          <div v-if="item.config && item.config.type == 'object-techrequirements'">
            <v-btn v-if="item.config.button" @click="getAppendixData(item.config, data)">Взять из объекта</v-btn>
            <a-input-object-techrequirements
              :value="item.data"
              @input="onInputTemplateData($event, 'data', item, idEdit)"
              :model="{ name: 'data', title: 'Техническое задание', type: 'object-techrequirements' }"
            />
          </div>
          <div v-if="item.config && item.config.type == 'protocol'">
            <a-input-object-techrequirements
              :value="item.data"
              @input="onInputTemplateData($event, 'data', item, idEdit)"
              :model="{
                name: 'data',
                title: 'Разногласия',
                type: 'object-techrequirements',
                modelItem: item.config.modelItem,
              }"
            />
          </div>
          <div v-if="item.config && item.config.type == 'object-gallery'">
            <v-btn v-if="item.config.button" @click="getAppendixData(item.config, data)">Взять из объекта</v-btn>
            <a-input-object-gallery v-model="item.data" :model="{ name: 'data', title: 'Галерея', type: 'object-gallery', video: false }" />
          </div>
          <div v-if="item.config && item.config.type == 'object-schedule'">
            <v-btn v-if="item.config.button" @click="getAppendixData(item.config, data)">Взять из объекта</v-btn>
            <a-input-object-schedule v-model="item.data" />
          </div>
        </template>
      </s-document-dialogs-detail-edit>
    </portal>
    <v-dialog v-model="showinvoice" persistent scrollable @keydown.esc="showinvoice = false" transition="false">
      <v-btn style="position: absolute; right: 20px; top: 20px; z-index: 100" fab dark small color="blue-grey" title="Закрыть окно" @click="showinvoice = false">
        <v-icon dark> mdi-close </v-icon>
      </v-btn>
      <v-card style="position: absolute; top: 10px; left: 10px; right: 10px; bottom: 10px; width: auto" height="auto">
        <ViewInvoice v-if="showinvoice" :idShow="invoice_id" @close="itemShowClose($event)" typeShow="dialog" />
      </v-card>
    </v-dialog>
    <s-edit-form-async ref="editField" />
    <a-loader v-if="loading" />
    <ScheduleDialog v-if="showScheduleEdit" v-model="showScheduleEdit" :contract="data" @createSchedule="onCreateSchedule($event)" />
  </static-fullscreen-card>
</template>

<script>
import { autoHeightBlock, getAccess, popupMenu, removeEl, genModel, statusDoc, validate, dataUtils } from "@/components/mixings";
export default {
  mixins: [autoHeightBlock, getAccess, popupMenu, removeEl, genModel, statusDoc, validate, dataUtils],
  props: {
    idShow: Number,
  },
  components: {
    TabAppendix: () => import("./tabs/tabContractAppendix"),
    TabContract: () => import("./tabs/tabContract"),
    ViewInvoice: () => import("@/views/documents/views/invoiceView"),
    ScheduleDialog: () => import("./../dialogs/paymentScheduleDialog"),
  },
  data() {
    return {
      suEditShow: false,
      showinvoice: false,
      needUpdateComments: 0,
      id: 0,
      idEdit: 0,
      idDeleting: 0,
      fieldsRO: [],
      fab: false,
      suEditShow: false,
      showEditDialog: false,
      showAppendixEditDialog: false,
      removeDialogShow: false,
      removeTitle: "Вы действительно хотите удалить документ?",
      showAddDocDialog: false,
      addDocModel: null,
      loading: false,
      loaded: false,
      title: "",
      data: {},
      m: null, //this.$store.getters["config/get"].models.contracts,
      tab: 0,
      validate_model: null,
      configH: null,
      invoice_id: null,
      showScheduleEdit: false,
    };
  },
  created() {
    this.initForm();
    return;
    this.loading = true;
    this.m = Object.assign({}, this.$store.getters["config/get"].models.contracts);
    this.$root.title = this.m.title;
    this.id = this.idShow || Number(this.$route.params.id);
    //    this.permit = this.getAccess("menu.objects");
    this.fitchData();
    this.loaded = true;
  },
  mounted() {},

  computed: {
    invoice_btn_title() {
      if (this.invoice_id === null) {
        this.getInvoice();
      } else if (this.invoice_id > 0) {
        return `Перейти к счету на оплату`;
      } else return `Создать счет на оплату`;
    },

    isQuickShow() {
      return this.showinvoice;
    },
    tabs() {
      if (!this.data) return [];
      return [
        { name: "files", title: "Документы", show: true },
        { name: "appendix", title: "Приложения", show: true },
        { name: "addition", title: "Дополнения", show: !this.data.parent_id },
        { name: "comments", title: "Комментарии", show: this.getAccess(`contract.comments`, null, true) },
        { name: "statusHistory", title: "История статусов", show: this.getAccess("contract.statusHistory") },
      ];
    },

    cost_contract() {
      let res = null;
      const d = (this.data?.template_data || []).find(t => t.type == 4);
      if (d) {
        res = 0;
        (d?.data || []).forEach(r => (res += +r.work_cost));
      }
      if (!res) res = this.data.data?.price || 0;
      let cost_contract = { price: res, prepay: Math.round((res * (this.data?.data?.prepay || 0)) / 100) };
      return cost_contract;
    },
    accDocName() {
      return this.m.accDocName;
    },
    api() {
      return this.m.api;
    },
    url() {
      return this.m.api;
    },

    accessEdit() {
      return this.getAccess("contract.edit", { users: [this.data.createdby_id] });
    },

    canEdit() {
      return true;
    },
    canDelete() {
      return true;
    },
    modelLeft() {
      let model = this.calcModel("viewForm1");
      return model;
    },
    modelRight() {
      let model = this.calcModel("viewForm2");
      model.push({ name: "prepay_contract", title: "Предоплата по договору", value: this.cost_contract?.prepay || 0, type: "number", showNull: true });
      model.push({ name: "price_contract", title: "Сумма по договору", value: this.cost_contract?.price || 0, type: "number", showNull: true });
      return model;
    },
    configHead() {
      return this.m.config.default || {};
    },
    model: {
      get() {
        let conf = JSON.parse(JSON.stringify(this.m?.config || {}));
        const f = conf?.watch;
        let config;
        if (f) {
          config = conf?.[this.data[f]];
        }
        config = config || conf.default;
        // this.configHead = config;
        let model = this.calcModelConfig(config);
        //console.log("model", config, model);
        return model;
      },
    },
    appendixTable: {
      get() {
        let res = [...(this.data.template_data || [])];
        res.forEach((r, i) => (r.id = i + 1));
        return res;
      },
      set(v) {
        let res = [...v];
        res.forEach(r => delete r.id);
        this.editAppendixAction(res);
      },
    },
  },
  watch: {
    showinvoice(v) {
      if (!v) {
        this.invoice_id = null;
      }
    },
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
        this.configH = null;
      }
    },
    showDialogEditDetail(v) {
      if (!v) {
        this.fitchData();
      }
    },
    showAddDocDialog(v) {
      if (!v) {
        this.fitchData();
      }
    },
  },
  methods: {
    async checkReqData(v, status) {
      const c = this.m.configReqData;
      let config = c?.[this.data.contract_type];
      if (!config) {
        this.$root.$emit("show-info", {
          text:
            "Не настроены условия для отправки на проверку для [" +
            (this.model.find(m => m.name == "contract_type")?.options || []).find(o => o.value == this.data.contract_type)?.text +
            "]",
          type: "error",
        });
        return false;
      }
      if (config?.needCheck === false) return true;
      if (config.side_2_vendor_data) {
        let vendor_type = config.side_2_vendor_data?.type?.[this.data.side_2_vendor_data?.type];
        let m_vendor = this.$store.getters["config/get"].models.dir_vendor;
        if (!vendor_type) {
          this.$root.$emit("show-info", {
            text: "Не настроены условия для поставщика с типом [" + (m_vendor?.vendorTypeList || []).find(o => o.value == this.data.side_2_vendor_data?.type)?.text + "]",
            type: "error",
          });
          return false;
        }
        let model_vendor = this.calcModelConfig({ fields: vendor_type.fields.join(",") }, m_vendor);
        this.validate_model = model_vendor;
        model_vendor.forEach(m => {
          let validator = m?.validator || [];
          if (!validator.includes("req")) validator.unshift("req");
          m.validator = [...(validator || [])];
        });
        let errors = await this.validateData(this.data?.side_2_vendor_data || {}, model_vendor, !true, true);
        this.validate_model = null;
        let textError = ["У Указанного поставщика в договоре следующие ошибки"];
        if (errors !== true) {
          for (const k in errors) {
            if (errors[k]) {
              let n = model_vendor.find(m => m.name == k).title;
              textError = [...(textError || []), `${n}: ${errors[k]}`];
            }
          }
          textError.push("Необходимо это исправить перед отправкой на проверку");
          await this.$root.$confirm({
            title: "Внимание ",
            message: textError,
            okButton: "Понятно",
            cancelButton: "Закрыть",
          });
          return false;
        }
        if ((vendor_type?.documents || []).length) {
          let textError = ["У Указанного поставщика в договоре нет документов со следующими типами:"];
          let resp = await this.$axios.post("/report_sql", {
            name: "getFileTypeList",
            params: { parent_name: "accounting_dir_vendors", parent_id: this.data.side_2_vendor_id },
          });
          let docs = (resp?.data?.data || []).map(d => d.type);
          vendor_type.documents.forEach(d => {
            let doc = d.split(",");
            if (doc.some(v => docs.includes(v))) {
            } else {
              let list = m_vendor.form.find(f => f.name == "docs").params.types;
              let names = doc.map(d => {
                return list.find(l => d.includes(l.value))?.text || d;
              });
              textError = [...(textError || []), `${names.join(" или ")}`];
            }
          });
          if (textError.length > 1) {
            textError = [...textError, "Перейдите в карточку поставщика и добавьте необходимые документы."];
            await this.$root.$confirm({
              title: "Внимание ",
              message: textError,
              okButton: "Понятно",
              cancelButton: "Закрыть",
            });
            return false;
          }
        }
        return true;
      }
      this.$root.$emit("show-info", {
        text: "Нет условий для проверки документа",
        type: "error",
      });
      return false;
      return true;
    },

    async initForm(id = 0) {
      this.loading = true;
      this.m = Object.assign({}, this.$store.getters["config/get"].models.contracts);
      this.$root.title = this.m.title;
      this.id = id || this.idShow || Number(this.$route.params.id);
      await this.fitchData();
      this.tab = 0;
      this.loaded = true;
    },
    scheduleDialog() {
      this.showScheduleEdit = true;
    },
    itemShowClose() {
      this.showinvoice = !true;
    },
    async getInvoice() {
      let resp = await this.$axios.get("/accounting/doc/invoice", { params: { filters: { parent_id: this.id, status: [1, 2], deleted: 0 } } });
      this.invoice_id = resp.data.data?.[0]?.id || 0;
    },
    async makeInvoice() {
      //      await this.$axios.get("/accounting/doc/invoice/token/4590b2a958eff4c058ec8f2e8905ce3e");
      let resp;
      let id = this.invoice_id;
      // let client = await this.$root.getDataById("client", this.data.side_2_client_id);
      // let vendor = await this.$root.getDataById("vendor", this.data.side_1_vendor_id);
      // return;
      let inv = {
        vendor_id: this.data.side_1_vendor_id,
        amount: this.cost_contract.prepay,
        parent_name: this.m.accDocName,
        parent_id: this.id,
      };
      if (id) {
        inv["id"] = id;
      } else {
        inv["status"] = 1;
        resp = await this.$axios.post("/accounting/doc/invoice", inv);
        id = resp.data?.data?.id || 0;
      }
      if (id) {
        this.invoice_id = id;
        this.showinvoice = true;
        return;
      }
    },
    onChange(e) {
      if (e.e == "type" && e.s) {
        this.setAppendixTemplate(e.d.type);
        //      this.$refs.editAppendix.updateDataField("data", e);
      }
    },
    async setAppendixTemplate(type) {
      let resp = await this.$axios.post("/report_sql", { name: "getContractAppendixTemplates", params: { id: this.data.id, parent_id: this.data?.parent?.id || null } });
      if (resp.data.status == "ok") {
        const t = resp.data.data.find(d => d.data?.appendix === type || JSON.parse(d.data || "")?.appendix === type);
        this.$refs.editAppendix.updateDataField("template_id", t?.id || null);
      }
    },
    onInputTemplateData(e, el, d) {
      let parent = "";
      //this.$set(this.data, "data", e);
      this.$refs.editAppendix.updateDataField("data", e);
    },
    getPreview() {
      return this.$root.config.baseUrl + `/accounting/dir/contract/print_doc/${this.id}?token=` + localStorage.getItem("user-token");
    },
    async getAppendixData(config, data) {
      if (config.type == "object-techrequirements") {
        if (!this.data.object_id) return;
        let resp = await this.$axios.get("/mechti/objects/" + this.data.object_id);
        data.data = resp.data.data[config.field];
      }
      if (config.type == "object-gallery") {
        if (!this.data.object_id) return;
        let resp = await this.$axios.get("/mechti/objects/" + this.data.object_id);
        data.data = resp.data.data[config.field];
      }
      if (config.type == "object-schedule") {
        if (!this.data.object_id) return;
        let resp = await this.$axios.get("/mechti/construction-schedule", { params: { filters: { object_id: this.data.object_id } } });
        const res = resp.data.data.map(d => {
          return {
            _id: d.id,
            id: d.id,
            service_id: d.service_id,
            name: d.name,
            department: d.department,
            work_days: d.work_days,
            work_cost: d.work_cost,
            description: d?.data?.description,
            date_start: d.date_start,
            date_end: d.date_end,
            square: this.data?.object_data?.ap_area || 1,
            price_square: d.work_cost / (this.data?.object_data?.ap_area || 1),
          };
        });
        this.$refs.editAppendix.updateDataField("data", res);
      }
    },

    async editAppendixAction(d) {
      const api = this.url;
      const template_data = d;
      const data = { id: this.id, template_data };
      let response = await this.$axios.post(api, data);
      let status = response.data.status == "ok";
      if (status) {
        this.$root.$emit("show-info", {
          text: "Данные сохранены",
        });
      } else {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка изменения данных",
        });
      }
      await this.fitchData();
    },

    async beforeChangeStatus(status) {
      if ([1, 2].includes(status.value)) {
        return await this.validateData(this.data, this.model, true);
      }
      if ([10, 11].includes(status.value)) {
        let res = await this.callForm({
          title: "Комментарий",
          data: { status_history_comment: "" },
          model: [{ name: "status_history_comment", title: "Описание", type: "text", validator: ["req"] }],
          btn: { ok: "Отправить", cancel: "Отмена" },
        });
        if (res) {
          console.log(res);
          status["status_history_comment"] = res.status_history_comment;
          return true;
        } else {
          return false;
        }
      }
      return true;
    },

    addNewDocs(field) {
      this.addDocModel = this.model.find(el => el.name == field);
      if (!this.addDocModel) return;
      this.showAddDocDialog = true;
    },

    getDetailsModel(n) {
      return this.m["list" + n.upFirst()];
    },

    async fitchData() {
      this.loading = true;
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
      }
      this.afterFetchData();
      this.loading = false;
    },
    afterRemove(data) {
      this.removeDialogShow = false;
      if (this.data.parent_id) {
        if (this.idShow) this.$emit("close", this.data);
        this.onClickRow({ row: { id: this.data.parent_id } });
      } else {
        if (this.idShow) this.$emit("close", this.data);
        else this.$router.push({ name: "contracts" });
      }
    },
    afterFetchData(r) {
      if (this.id) {
        //   this.calcModel();
      }
      this.data["cost_contract"] = this.cost_contract;
      this.m = this.initModel(this.m, { values: this.data });
      this.loaded = true;
      // this.initType = null;

      //  this.calcModel(1);
    },

    onClickRow(e, d = {}) {
      const id = e.row.id;

      if (id) {
        if (this.idShow) {
          this.idShow = id;
        } else {
          this.$router.push({ name: "contracts_view", params: { id } });
        }
        this.initForm(id);
      }
      return;
      if (e.field?.isMenu) {
        let name = e.field?.alias || e.field.name;
        let id = e.row?.[e.field.name];
        if (id) this.showPopupMenu(name, e.row, e.event, { task: { id: e.row[e.field.name] } });
      } else if (e.field.name == "actions") {
      } else {
        if (["rooms", "works", "goods"].includes(d.name)) {
          this.idEdit = e.row.id;
          this.detailIndex = d.detailIndex;
          this.detailName = d.name;
          this.fieldsRO = [];
          this.showDialogEditDetail = true;
          return;
        }
      }
    },
    appendixAdd(e) {
      this.idEdit = 0;
      this.showAppendixEditDialog = true;
    },
    appendixEdit(e) {
      //this.idEdit = e.key + 1;
      this.idEdit = e.row.id;
      this.showAppendixEditDialog = true;
    },
    appendixDelete(e) {
      return this.editAppendixAction(e);
    },
    async additionAdd() {
      if (this.loading) return;
      this.loading = true;
      if (!this.m) return;
      const config = {};
      this.m.config["addition"] = {};
      config.type = "default";
      this.configH = null;
      config.head = {
        fields: "contract_type,status",
        fieldsRO: "",
        fieldsForm: "contract_type",
      };
      config.title = this.m.title || "";
      config.api = this.m.api;
      config.id = 0;
      config.opt = {
        fieldsEditable: "*",
        //delete: this.getAccess("contract.delete")
      };
      config.initData = {
        parent_name: this.m.accDocName,
        parent_id: this.id,
        name: "Дополнение к договору",
        contract_number: this.data.contract_number,
        contract_type: this.data.contract_type,
        type: 2,
        // template_id: this.data.template_id,
        status: 0,
      };
      config.m = this.m;
      //this.configH = Object.assign({}, config);
      //console.log(config);
      let response = await this.$axios.post(config.api, config.initData);
      if (response?.data?.status == "ok") {
        //console.log("ok", response.data);
        const id = response.data?.id;

        //   if (id) this.initForm(id);
      }
      //console.log(this.$refs.tableAddition);
      this.$refs.tableAddition[0].updateData();
      this.loading = false;
      //      this.showEditDialog = true;
    },
    contractEdit() {
      if (!this.m) return;
      const config = {};
      config.type = "default";
      this.configH = null;
      config.head = this.m.config.default || {};
      config.title = this.m.title || "";
      config.api = this.m.api;
      config.id = this.id;
      // config.opt = { delete: this.getAccess("contract.delete") };
      config.m = this.m;
      this.configH = Object.assign({}, config);
      //console.log(config);
      this.showEditDialog = true;
    },
    onCreateSchedule(e) {},
    async callForm(e) {
      return this.$refs.editField.show(e);
    },
  },
};
</script>
